import EnrollmentsService from "@/services/EnrollmentsService";
import {
    addItemToList,
    findItemInList,
    getListItems,
    getListPagination,
    removeItemFromList,
    replaceItemInList
} from "@/utils/listHelpers";
import { notifyStoreError } from "@/utils/storeHelpers";

export default {
    state: {
        enrollments: [],
    },

    mutations: {
        setEnrollments(state, enrollments) {
            state.enrollments = enrollments;
        },


        updateEnrollmentInList(state, updatedEnrollment) {
            if (!updatedEnrollment) return

            state.enrollments = replaceItemInList(state.enrollments, updatedEnrollment);
        },

        createEnrollment(state, enrollment) {
            if (!enrollment) return

            state.enrollments = addItemToList(state.enrollments, enrollment);
        },

        deleteEnrollmentFromList(state, enrollmentId) {
            state.enrollments = removeItemFromList(state.enrollments, enrollmentId);
        }
    },

    actions: {
        async getEnrollments({ commit, dispatch }, payload) {
            try {
                const response = await EnrollmentsService.getEnrollments(payload.data, payload.userToken);

                commit('setEnrollments', response);
            } catch (error) {
                notifyStoreError(dispatch, 'Falha ao requisitar matrículas, tente novamente em breve', error);
            } finally {
                if (payload.skeletonKey) {
                    dispatch('skeleton/setLoadingState', { key: payload.skeletonKey, value: false });
                }
            }
        },

        async createEnrollment({ commit, dispatch, state }, payload) {
            try {
                const response = await EnrollmentsService.createEnrollment(payload.data, payload.userToken);
                const enrollment = response.data;

                if (enrollment && findItemInList(state.enrollments, enrollment.id)) {
                    dispatch('toastfy/activeInfoNotification', { text: 'O usuário já está matriculado nesta turma.' });
                    return;
                }

                commit('createEnrollment', enrollment);
                dispatch('toastfy/activeSuccesNotification', { text: 'Matrícula criada com sucesso!' });
            } catch (error) {
                notifyStoreError(dispatch, 'Falha ao criar matrícula, tente novamente em breve', error);
            }
        },

        async updateEnrollment({ commit, dispatch }, payload) {
            try {
                const response = await EnrollmentsService.updateEnrollment(payload.data, payload.userToken);

                commit('updateEnrollmentInList', response.data);
            } catch (error) {
                notifyStoreError(dispatch, 'Falha ao atualizar matrícula, tente novamente em breve', error);
            }
        },

        async restoreEnrollment({ commit, dispatch }, payload) {
            try {
                await EnrollmentsService.restoreEnrollment(payload.enrollmentId, payload.userToken);

                commit('deleteEnrollmentFromList', payload.enrollmentId);
                dispatch('toastfy/activeSuccesNotification', { text: 'Matrícula restaurada com sucesso!' });
            } catch (error) {
                notifyStoreError(dispatch, 'Falha ao restaurar matrícula, tente novamente em breve', error);
            }
        },

        async fetchAddressByCep({ dispatch }, payload) {
            try {
                return await EnrollmentsService.fetchAddressByCep(payload.cep);
            } catch (error) {
                notifyStoreError(dispatch, 'Falha ao buscar endereço pelo CEP, tente novamente em breve', error);
                return null
            }
        },

        async deleteEnrollment({ commit, dispatch }, payload) {
            try {
                await EnrollmentsService.deleteEnrollment(payload.enrollmentId, payload.userToken);

                commit('deleteEnrollmentFromList', payload.enrollmentId);
                dispatch('toastfy/activeSuccesNotification', { text: 'Matrícula excluída com sucesso!' });
            } catch (error) {
                notifyStoreError(dispatch, 'Falha ao excluir matrícula, tente novamente em breve', error);
            }
        },
    },

    getters: {
        getEnrollments(state) {
            return getListItems(state.enrollments);
        },
        getEnrollmentsPagination(state) {
            return getListPagination(state.enrollments);
        },
    },
}
